import { render } from "./Whatsapp.vue?vue&type=template&id=45b221a0"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Whatsapp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45b221a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45b221a0', __exports__)) {
    api.reload('45b221a0', __exports__)
  }
  
  module.hot.accept("./Whatsapp.vue?vue&type=template&id=45b221a0", () => {
    api.rerender('45b221a0', render)
  })

}


export default __exports__